export default "__VITE_ASSET__BHfJna17__"